<app-text-input
    label="Business/Organisation Name"
    shortLabel="name"
    [control]="businessEnquiryForm.controls.name"
    >
</app-text-input>
<app-text-input
    label="Australian Business Number (ABN)"
    shortLabel="ABN"
    [control]="businessEnquiryForm.controls.abn"
    > 
</app-text-input>
<div class="question-container">
    <label>Best Contact Person</label>
    <app-text-input
        label="First Name"
        [control]="businessEnquiryForm.controls.firstname"
        >
    </app-text-input>
    <app-text-input
        label="Surname"
        [control]="businessEnquiryForm.controls.surname"
        >   
    </app-text-input>

</div>
<app-text-input
    label="Best Contact Person Email"
    shortLabel="Email"
    [control]="businessEnquiryForm.controls.email"
    > 
</app-text-input>

      <app-phone-input label="Best Contact Person Phone Number"
        [phoneTypes]="phoneTypes"
        [phoneTypeControl]="businessEnquiryForm.controls.phoneType"
        [phoneCountryCodeControl]="businessEnquiryForm.controls.phoneCountryCode"
        [phoneAreaCodeControl]="businessEnquiryForm.controls.phoneAreaCode"
        [phoneNumberControl]="businessEnquiryForm.controls.phoneNumber">
      </app-phone-input>